import { resolveComponent as _resolveComponent, createVNode as _createVNode, withModifiers as _withModifiers, createElementVNode as _createElementVNode, withCtx as _withCtx, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-7d2c70f6"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
    ref: "golden-layout-data",
    id: "golden-layout-data"
};
const _hoisted_2 = {
    key: 0,
    class: "splash-screen"
};
const _hoisted_3 = { class: "container-fluid p-3" };
const _hoisted_4 = {
    style: { "float": "right", "margin-left": "0.5rem" },
    class: "d-none d-sm-block"
};
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("img", {
    src: "img/icons/android-chrome-192x192.png",
    class: "rounded mx-auto d-block",
    alt: "Logo",
    style: { "width": "128px", "height": "128px" }
}, null, -1));
const _hoisted_6 = { class: "text-center" };
const _hoisted_7 = ["innerHTML"];
const _hoisted_8 = /*#__PURE__*/ _createTextVNode(" To get started, take a look at the ");
const _hoisted_9 = /*#__PURE__*/ _createTextVNode(", read the ");
const _hoisted_10 = /*#__PURE__*/ _createTextVNode(", " + " or load some ");
const _hoisted_11 = /*#__PURE__*/ _createTextVNode(". ");
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("div", { id: "golden-layout" }, null, -1));
export function render(_ctx, _cache, $props, $setup, $data, $options) {
    const _component_TreeView = _resolveComponent("TreeView");
    const _component_GoldenLayoutComponent = _resolveComponent("GoldenLayoutComponent");
    const _component_PluginPathLink = _resolveComponent("PluginPathLink");
    const _component_ViewerPanel = _resolveComponent("ViewerPanel");
    const _component_QueuePanel = _resolveComponent("QueuePanel");
    const _component_DataPanel = _resolveComponent("DataPanel");
    const _component_GoldenLayoutContainer = _resolveComponent("GoldenLayoutContainer");
    const _component_StylesPanel = _resolveComponent("StylesPanel");
    const _component_InformationPanel = _resolveComponent("InformationPanel");
    const _component_LogPanel = _resolveComponent("LogPanel");
    return (_openBlock(), _createElementBlock("span", null, [
        _createElementVNode("div", _hoisted_1, [
            _createVNode(_component_GoldenLayoutContainer, { type: "column" }, {
                default: _withCtx(() => [
                    _createVNode(_component_GoldenLayoutContainer, {
                        type: "row",
                        height: 80
                    }, {
                        default: _withCtx(() => [
                            _createVNode(_component_GoldenLayoutComponent, {
                                name: "Navigator",
                                extraClass: "sortable-group",
                                state: "{}",
                                width: 20
                            }, {
                                default: _withCtx(() => [
                                    _createElementVNode("div", {
                                        onClick: _cache[0] || (_cache[0] = _withModifiers(
                                        //@ts-ignore
                                        (...args) => (_ctx.clearSelection && _ctx.clearSelection(...args)), ["self"])),
                                        style: { "height": "100%", "overflow-x": "clip" }
                                    }, [
                                        _createVNode(_component_TreeView)
                                    ])
                                ]),
                                _: 1
                            }),
                            _createVNode(_component_GoldenLayoutContainer, {
                                type: "stack",
                                width: 60
                            }, {
                                default: _withCtx(() => [
                                    _createVNode(_component_GoldenLayoutComponent, {
                                        name: "Viewer",
                                        state: "{}",
                                        style: 'height:100%; padding:0 !important;'
                                    }, {
                                        default: _withCtx(() => [
                                            (!_ctx.viewerLoaded)
                                                ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
                                                    _createElementVNode("div", _hoisted_3, [
                                                        _createElementVNode("div", _hoisted_4, [
                                                            _hoisted_5,
                                                            _createElementVNode("p", _hoisted_6, _toDisplayString(_ctx.appInfo), 1)
                                                        ]),
                                                        _createElementVNode("p", null, [
                                                            _createElementVNode("span", { innerHTML: _ctx.appDescription }, null, 8, _hoisted_7),
                                                            _createTextVNode(" " + _toDisplayString(_ctx.appName) + " is freely accessible for personal, academic, and commercial use, without login or registration. ", 1)
                                                        ]),
                                                        _createElementVNode("p", null, [
                                                            _hoisted_8,
                                                            _createVNode(_component_PluginPathLink, {
                                                                plugin: "help",
                                                                title: _ctx.appName + ' Help System'
                                                            }, null, 8, ["title"]),
                                                            _hoisted_9,
                                                            _createVNode(_component_PluginPathLink, {
                                                                plugin: "documentation",
                                                                title: "documentation"
                                                            }),
                                                            _hoisted_10,
                                                            _createVNode(_component_PluginPathLink, {
                                                                plugin: "openexampleproject",
                                                                title: "example data"
                                                            }),
                                                            _hoisted_11
                                                        ])
                                                    ])
                                                ]))
                                                : _createCommentVNode("", true),
                                            _createVNode(_component_ViewerPanel, { onOnViewerLoaded: _ctx.onViewerLoaded }, null, 8, ["onOnViewerLoaded"])
                                        ]),
                                        _: 1
                                    }),
                                    _createVNode(_component_GoldenLayoutComponent, {
                                        name: "Jobs",
                                        state: "{}"
                                    }, {
                                        default: _withCtx(() => [
                                            _createVNode(_component_QueuePanel)
                                        ]),
                                        _: 1
                                    }),
                                    _createVNode(_component_GoldenLayoutComponent, {
                                        name: "Data",
                                        state: "{}"
                                    }, {
                                        default: _withCtx(() => [
                                            _createVNode(_component_DataPanel)
                                        ]),
                                        _: 1
                                    })
                                ]),
                                _: 1
                            }),
                            _createVNode(_component_GoldenLayoutContainer, {
                                type: "column",
                                width: 20
                            }, {
                                default: _withCtx(() => [
                                    _createVNode(_component_GoldenLayoutComponent, {
                                        name: "Styles",
                                        state: "{}",
                                        width: 20,
                                        height: 75
                                    }, {
                                        default: _withCtx(() => [
                                            _createVNode(_component_StylesPanel)
                                        ]),
                                        _: 1
                                    }),
                                    _createVNode(_component_GoldenLayoutComponent, {
                                        name: "Information",
                                        state: "{}",
                                        width: 20,
                                        height: 25
                                    }, {
                                        default: _withCtx(() => [
                                            _createVNode(_component_InformationPanel)
                                        ]),
                                        _: 1
                                    })
                                ]),
                                _: 1
                            })
                        ]),
                        _: 1
                    }),
                    _createVNode(_component_GoldenLayoutContainer, {
                        type: "row",
                        height: 20
                    }, {
                        default: _withCtx(() => [
                            _createVNode(_component_GoldenLayoutComponent, {
                                name: "Log",
                                state: "{}",
                                paddingSize: 2
                            }, {
                                default: _withCtx(() => [
                                    _createVNode(_component_LogPanel)
                                ]),
                                _: 1
                            })
                        ]),
                        _: 1
                    })
                ]),
                _: 1
            })
        ], 512),
        _hoisted_12
    ]));
}
